import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.0005 16.4921V7.2906L15.7147 3l-7.4909.0297L3 7.2924v9.1955l5.2067 4.5142h7.5266zM9.029 5.2756l5.891-.0233 1.4418 1.1702L6.3611 16.4232l-1.1113-.9635V8.3595zM8.0655 17.901l9.9803-9.9803a1.1 1.1 0 0 0 .0688-.0753l.6356.516v7.0942l-3.8488 3.2956H9.0461z",
    clipRule: "evenodd"
}), "StatusRejected", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
